import { Transaction } from "src/containers/crm/types";

/**
 * TransactionDto {
 *   'numeroSiniestro': claimNumber,
 *   'accion': event.name,
 *   'codigoProducto': product,
 *   'codigoSistema': systemCode,
 *   'codigoPoliza': policyId,
 * };
 */
export class TransactionDto {
    action: string;
    systemCode?: string | null;
    policyId?: string | number | null;
    product?: string | null;
    claimNumber?: string | null;

    private constructor(
        action: string,
        systemCode?: string | null,
        policyId?: string | number | null,
        product?: string | null,
        claimNumber?: string | null
    ) {
        this.action = action;
        this.systemCode = systemCode ?? null;
        this.policyId = policyId ?? null;
        this.product = product ?? null;
        this.claimNumber = claimNumber ?? null;
    }

    static fromModel(transaction: Transaction): TransactionDto {
        return new TransactionDto(
            transaction.action,
            transaction.systemCode ?? null,
            transaction.policyId ?? null,
            transaction.product ?? null,
            transaction.claimNumber ?? null
        );
    }

    asDtoObject(): Record<string, any> {
        return {
            'datos': {
                'accion': this.action,
                'codigoSistema': this.systemCode,
                'codigoPoliza': this.policyId,
                'codigoProducto': this.product,
                'numeroSiniestro': this.claimNumber,
            }
        };
    }
}